import deskdoc from "../img/portImages/deskdoc.png";
import deskdocWebp from "../img/portImages/deskdoc.webp";
import finovaai from "../img/portImages/finovaai.png";
import finovaaiWebp from "../img/portImages/finovaai.webp";

export const featuredProjects = [
  {
    id: "deskdoc",
    image: deskdoc,
    imageWebp: deskdocWebp,
    imageWidth: 700,
    imageHeight: 438,
    link: "https://deskdoc.in",
    title: "DeskDoc",
    text: "AI voice receptionist for clinics — cuts average call handling time by 40%.",
    stack: ["Vapi", "OpenAI", "Node.js"],
  },
  {
    id: "finovaai",
    image: finovaai,
    imageWebp: finovaaiWebp,
    imageWidth: 700,
    imageHeight: 438,
    link: "https://finova-ai-official.vercel.app",
    title: "FinovaAI",
    text: "Personal finance app.",
    stack: [],
  },
];

export const earlierProjects = [
  {
    id: 1,
    category: "Android (Java)",
    link: "https://github.com/suyalamritanshu/Juit-College",
    title: "Juit College",
    text: "College admin app for posting and viewing notices.",
  },
  {
    id: 2,
    category: "React Js",
    link: "https://github.com/suyalamritanshu/Netflix-Clone",
    title: "Netflix Clone",
    text: "Netflix clone with auth and full video playback, backed by a custom API.",
  },
  {
    id: 3,
    category: "Android (Kotlin)",
    link: "https://github.com/suyalamritanshu/Jokes-App",
    title: "Jokes App",
    text: "Random jokes with a random background on each click.",
  },
  {
    id: 4,
    category: "Vue Js",
    link: "https://github.com/suyalamritanshu/Weather-Vue-App",
    title: "Weather App",
    text: "Weather lookup via the OpenWeatherMap API, background matches conditions.",
  },
  {
    id: 5,
    category: "Vue Js",
    link: "https://github.com/suyalamritanshu/Music-Vue-App",
    title: "Music App",
    text: "Music player with play/pause/skip controls.",
  },
  {
    id: 6,
    category: "Node Js",
    link: "https://github.com/suyalamritanshu/Netflix---Api",
    title: "Netflix Api",
    text: "Backend API for the Netflix clone — movie listings, user registration.",
  },
  {
    id: 7,
    category: "Next Js",
    link: "https://github.com/suyalamritanshu/Hulu-Clone",
    title: "Hulu Clone",
    text: "Hulu clone using the TMDB API, responsive from mobile to 4K.",
  },
  {
    id: 8,
    category: "Javascript",
    link: "https://github.com/suyalamritanshu/Pizza-App-Socket",
    title: "Realtime Pizza App",
    text: "Realtime ordering app with admin panel and order tracking.",
  },
  {
    id: 9,
    category: "Javascript",
    link: "https://github.com/suyalamritanshu/Realtime-Chat-App",
    title: "Realtime Chat App",
    text: "Realtime chat app with rooms and emoji support.",
  },
  {
    id: 10,
    category: "Android (Kotlin)",
    link: "https://github.com/suyalamritanshu/Qr-Code-Scanner",
    title: "Qr Code Scanner App",
    text: "Scans QR codes and barcodes.",
  },
  {
    id: 11,
    category: "Android (Java)",
    link: "https://github.com/suyalamritanshu/Dictionary-App",
    title: "Dictionary App",
    text: "English dictionary with pronunciation audio, via a dictionary API.",
  },
];
